"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSettingByAlias = void 0;
var getSettingByAlias = function (alias, register) {
    var _a;
    return (_a = register.settings) === null || _a === void 0 ? void 0 : _a[alias];
};
exports.getSettingByAlias = getSettingByAlias;
//# sourceMappingURL=Register.js.map